import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.274 13l-3.256-3.256 1.414-1.414 5.657 5.657-5.657 5.657-1.414-1.415L18.248 15h-7.173v-2h7.199zM5.815 9h7.199v2H5.842l3.23 3.23-1.415 1.414L2 9.987 7.657 4.33 9.07 5.744 5.815 9z"
    />
  </svg>
);
